import _ from 'lodash';
import { DOCUMENTS_ERROR, DOCUMENTS_LOADING, DOCUMENTS_UPDATE } from '../actions/documentsActions';

const AVALIABLE_ACTION_TYPES = [
    DOCUMENTS_UPDATE,
    DOCUMENTS_ERROR,
    DOCUMENTS_LOADING,
];

const INITIAL_STATE_ITEM = {
    documents: [],
    documentsPagination: null,
    documentsLoading: false,
    documentsError: null,
};

const INITIAL_STATE = {};

const applyActionToItemState = (action, state = INITIAL_STATE_ITEM) => {
    switch ( action.type ) {
        case DOCUMENTS_UPDATE:
            return {
                ...state,
                documents: action.payload.data,
                documentsPagination: action.payload.pagination,
                documentsError: action.payload.message,
            };
        case DOCUMENTS_ERROR:
            return { ...state, documentsError: action.payload };
        case DOCUMENTS_LOADING:
            return { ...state, documentsLoading: action.payload };
        default:
            return state;
    }

};

export default (state = INITIAL_STATE, action) => {
    if ( AVALIABLE_ACTION_TYPES.indexOf(action.type) > -1 ) {
        const newState = _.cloneDeep(state);
        newState[action.id] = applyActionToItemState(action, state[action.id]);
        return newState;
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/app/documents/reducers/DocumentsReducer.js